import { render, staticRenderFns } from "./kv-message-renderer.vue?vue&type=template&id=6eb7a0a1"
import script from "./kv-message-renderer.vue?vue&type=script&lang=js"
export * from "./kv-message-renderer.vue?vue&type=script&lang=js"
import style0 from "./kv-message-renderer.vue?vue&type=style&index=0&id=6eb7a0a1&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports